import {TypefulModule} from "@/modules/typeful/TypefulModule";

export default new Map<string, TypefulModule>()
